var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlPanel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#B0B7C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.0567 7.5H20.5962C21.6479 7.5 22.5001 8.35939 22.5001 9.41997V11.9809C22.5001 13.0415 21.6479 13.9009 20.5962 13.9009H18.0567C17.005 13.9009 16.1528 13.0415 16.1528 11.9809V9.41997C16.1528 8.35939 17.005 7.5 18.0567 7.5Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9434 16.0991C12.9951 16.0991 13.8473 16.9585 13.8473 18.0191V20.58C13.8473 21.6399 12.9951 22.5 11.9434 22.5H9.40389C8.35219 22.5 7.5 21.6399 7.5 20.58V18.0191C7.5 16.9585 8.35219 16.0991 9.40389 16.0991H11.9434ZM20.5961 16.0991C21.6478 16.0991 22.5 16.9585 22.5 18.0191V20.58C22.5 21.6399 21.6478 22.5 20.5961 22.5H18.0566C17.0049 22.5 16.1527 21.6399 16.1527 20.58V18.0191C16.1527 16.9585 17.0049 16.0991 18.0566 16.0991H20.5961ZM11.9434 7.5C12.9951 7.5 13.8473 8.35939 13.8473 9.41997V11.9809C13.8473 13.0415 12.9951 13.9009 11.9434 13.9009H9.40389C8.35219 13.9009 7.5 13.0415 7.5 11.9809V9.41997C7.5 8.35939 8.35219 7.5 9.40389 7.5H11.9434Z",
    fill: "#B0B7C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlPanel);
export default __webpack_public_path__ + "static/media/ControlPanel.8924f64b1e2ddce78b20a4560af88500.svg";
export { ForwardRef as ReactComponent };